// extracted by mini-css-extract-plugin
module.exports = {"add":"new_add__4cGmA"};